import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../contexts/ThemeContext';
import '../styles/themeToggle.css';

const ThemeToggle = React.memo(() => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <button 
      className="theme-toggle" 
      onClick={toggleTheme}
      aria-label={isDark ? 'Переключить на светлую тему' : 'Переключить на темную тему'}
    >
      <div className="theme-toggle-inner">
        <div className={`theme-icon ${isDark ? 'active' : ''}`}>
          <Moon size={18} />
        </div>
        <div className={`theme-icon ${!isDark ? 'active' : ''}`}>
          <Sun size={18} />
        </div>
      </div>
      <div className="theme-toggle-glow"></div>
    </button>
  );
});

ThemeToggle.displayName = 'ThemeToggle';

export default ThemeToggle;